/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AttachPinIcon16Light } from './AttachPinIcon16Light';
import { AttachPinIcon16Regular } from './AttachPinIcon16Regular';
import { AttachPinIcon16Solid } from './AttachPinIcon16Solid';
import { AttachPinIcon20Light } from './AttachPinIcon20Light';
import { AttachPinIcon20Regular } from './AttachPinIcon20Regular';
import { AttachPinIcon20Solid } from './AttachPinIcon20Solid';
import { AttachPinIcon24Regular } from './AttachPinIcon24Regular';
import { AttachPinIcon24Solid } from './AttachPinIcon24Solid';
import { AttachPinIcon32Regular } from './AttachPinIcon32Regular';
import { AttachPinIcon64Regular } from './AttachPinIcon64Regular';
var sizes = {
    16: {
        light: AttachPinIcon16Light,
        regular: AttachPinIcon16Regular,
        solid: AttachPinIcon16Solid,
    },
    20: {
        light: AttachPinIcon20Light,
        regular: AttachPinIcon20Regular,
        solid: AttachPinIcon20Solid,
    },
    24: {
        regular: AttachPinIcon24Regular,
        solid: AttachPinIcon24Solid,
    },
    32: {
        regular: AttachPinIcon32Regular,
    },
    64: {
        regular: AttachPinIcon64Regular,
    },
};
export var AttachPinIcon = forwardRef('AttachPinIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
